export default __webpack_public_path__ + "static/media/031-foot.f1f25cce.svg";